// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"2f632de4","263":"4ca0f870","341":"a2a0b10a","522":"239f87f8","636":"c38394f6","787":"46afb3c4","835":"7fb28a50"}[chunkId] + ".chunk.js";
};